import { createSlice } from '@reduxjs/toolkit'
import { CURRENCY_DISPLAY_MAP } from '@constants/currencyConstants'

const initialState = {
  balance: 0,
  currencyCode: null,
  displayCurrencyCode: null,
}

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWallet: (state, action) => {
      const { balance, currencyCode } = action.payload
      state.balance = balance
      state.currencyCode = currencyCode
      state.displayCurrencyCode = CURRENCY_DISPLAY_MAP[currencyCode] ?? currencyCode
    },

    updateBalance: (state, action) => {
      state.balance = action.payload
    },

    setCurrencyCode: (state, action) => {
      const currencyCode = action.payload
      state.currencyCode = currencyCode
      state.displayCurrencyCode = CURRENCY_DISPLAY_MAP[currencyCode] ?? currencyCode
    },

    resetWallet: () => initialState,
  },
})

export const { setWallet, updateBalance, setCurrencyCode, resetWallet } = walletSlice.actions

export default walletSlice.reducer
